"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ProtegemosLoQueMSImporta() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="4268" id="protegemos-lo-que-más-importa" className="text-foreground relative min-h-screen w-full overflow-hidden">
      {}
      <div className="pointer-events-none absolute inset-0 z-30 opacity-[0.04] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/></filter><rect width='100%25' height='100%25' filter='url(%23n)'/></svg>\")"
    }} aria-hidden="true" />

      <div className="relative z-10 flex min-h-screen w-full flex-col lg:flex-row">
        {}
        <div ref={leftRef} className={`relative flex w-full flex-col justify-center px-6 py-16 sm:px-10 md:px-16 lg:w-[45%] lg:px-20 lg:py-24 transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="mb-12 flex items-center gap-3 lg:mb-16">
            <span className="font-mono text-base font-medium" style={{
            color: "var(--primary)"
          }}>
              § 01
            </span>
            <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
              GRUPO POSEIDÓN — SEGURIDAD PRIVADA
            </span>
          </div>

          {}
          <h1 className="font-default font-bold leading-[0.95] tracking-tight text-foreground text-[13vw] sm:text-[11vw] lg:text-[9vw] uppercase">
            <span className="block font-light">Protegemos</span>
            <span className="block font-bold" style={{
            color: "var(--primary)"
          }}>
              lo que más
            </span>
            <span className="block font-bold">importa.</span>
          </h1>

          {}
          <p className="mt-10 max-w-xl font-default text-lg md:text-xl leading-relaxed text-muted-foreground">
            Soluciones estratégicas de seguridad con disciplina, tecnología de vanguardia y el respaldo de la Agencia Nacional de Seguridad Privada Poseidón.
          </p>

          {}
          <div className="mt-16 flex flex-col items-start gap-6 sm:flex-row sm:items-center sm:gap-10">
            <Button asChild variant="outline" size="lg" className="group h-14 rounded-md border-[1px] bg-primary px-8 font-mono text-xs uppercase tracking-[0.2em] hover:bg-white hover:text-primary transition-all duration-300" style={{
            borderColor: "var(--primary)",
            color: "var(--primary-foreground)"
          }}>
              <Link to="/ContactPage">
                <span>Solicitar Cotización</span>
                <ArrowRight className="ml-2 size-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </Button>

            <Link to="/AboutUsPage" className="group relative font-mono text-base text-foreground uppercase tracking-wider">
              <span>Nuestra Misión</span>
              <span className="absolute -bottom-1 left-0 h-px w-full origin-left scale-x-0 transition-transform duration-500 ease-out group-hover:scale-x-100" style={{
              backgroundColor: "var(--primary)"
            }} />
            </Link>
          </div>

          {}
          <div className="absolute bottom-8 left-6 hidden items-center gap-4 sm:left-10 lg:left-20 lg:flex">
            <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-muted-foreground" style={{
            writingMode: "vertical-rl",
            transform: "rotate(180deg)"
          }}>
              Explorar
            </span>
            <div className="relative h-16 w-px overflow-hidden bg-border">
              <span className="absolute left-0 top-0 h-1/2 w-px animate-[scrollLine_2.2s_ease-in-out_infinite]" style={{
              backgroundColor: "var(--primary)"
            }} />
            </div>
          </div>
        </div>

        {}
        <div ref={rightRef} className={`relative w-full lg:w-[55%] transition-all duration-1000 ease-out delay-200 ${rightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
          <div className="relative h-[60vh] w-full overflow-hidden lg:h-screen lg:px-10 lg:py-12">
            <div className="relative h-full w-full overflow-hidden rounded-md shadow-2xl">
              {}
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/poseidon_security_monitoring_center.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/poseidon_security_monitoring_center.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/poseidon_security_monitoring_center.png-wvc-sizes" alt="Centro de monitoreo de seguridad de alta tecnología con pantallas y personal profesional" loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover grayscale-[0.3] contrast-[1.1]" />

              {}
              <div className="pointer-events-none absolute inset-0" style={{
              background: "radial-gradient(ellipse at 60% 50%, transparent 30%, hsl(220 15% 6% / 0.65) 100%)"
            }} aria-hidden="true" />

              {}
              <div className="pointer-events-none absolute inset-0 opacity-[0.06] mix-blend-overlay" style={{
              backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/></filter><rect width='100%25' height='100%25' filter='url(%23n)'/></svg>\")"
            }} aria-hidden="true" />

              {}
              <div className="absolute bottom-6 right-6 z-10 flex items-center gap-3 lg:bottom-8 lg:right-8 bg-background/80 backdrop-blur-md px-4 py-2 rounded-md">
                <span className="size-1.5 rounded-md animate-pulse" style={{
                backgroundColor: "var(--primary)"
              }} aria-hidden="true" />
                <span className="font-mono text-[9px] uppercase tracking-[0.25em] text-foreground">
                  SISTEMA ACTIVO · VIGILANCIA 24/7 · GRUPO POSEIDÓN
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes scrollLine {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(200%); }
        }
      `}</style>
    </section>;
}